<div class="menu-dropdown">
  <div (click)="toggle()">
    <user-icon-nav
      [initials]="data?.firstName ? data.firstName[0] + data.lastName[0] : 'BO'"
      [isActive]="on"
    ></user-icon-nav>
  </div>

  <div *ngIf="on" class="menu-dropdown-content" (click)="toggle()">
    <user-menu-main [user]="data"></user-menu-main>
    <user-menu-navigation [currency]="data?.preferences?.fiatCurrencyCode"></user-menu-navigation>
  </div>
</div>
<div *ngIf="on" class="menu-dropdown-dismiss" (click)="dismiss()"></div>
